module.exports = __webpack_public_path__ + "cc7ac13f1cbd900152b6856bd5acebb7.jpg";